import React, { useState, useEffect } from "react";
import { RxReload } from "react-icons/rx";
import "./AllUser.css";
import ExportIcon from "../../../components/Images/icons/Export_Icon_01.png";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import AdminDeleteModal from "../../../components/CommonComponents/AdminDeleteModal";
import AdminNavbar from "../../../components/CommonComponents/AdminNavbar";
import { toast } from "react-toastify";
import { statusActiveFormatteruser } from "../../../components/CommonMethod/CommonBoostrapFormatter";
import AdminTable from "../../../components/CommonComponents/AdminTable";
import { donwloadCSV, downloadPDF, downloadXLSX, findUploadName, videodownloadXLSX, videodownloadPDF } from "../../../components/CommonMethod/CommonMethods";
import { BiRecycle } from "react-icons/bi";
import { IconDeleteFigma, IconEditFigma } from "../../../Assets/MyIcons";
import { FaEllipsisVertical } from "react-icons/fa6";
import { LiaUndoAltSolid } from "react-icons/lia";
import { Link } from "react-router-dom";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import AdminTooltip from "../../../components/CommonComponents/AdminTooltip";
import useTablePage from "../../../components/CommonComponents/useTablePage";

function AllUser() {
  const BaseUrl = process.env.REACT_APP_Baseurl
  const listApi = `${BaseUrl}/admin/users/list`
  const multiDelete = `${BaseUrl}/admin/users/multi-delete`
  const { fetchRequest, deleteImageFile } = useMyContext()
  const { page, limit, handlePageChange, handleSizePerPageChange } = useTablePage(10);
  const [draft, setDraft] = useState(0);
  const [deleteActionType, setDeleteActionType] = useState(2);
  const [Permanent, setPermanent] = useState(0);
  const [type, setType] = useState(null)
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState('')
  const [itemToDelete, setItemToDelete] = useState([]);
  const [modelClose, setModelClose] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [withOutRefresh, setWithoutRefresh] = useState(false)
  const [showModal, setShowModal] = useState(false);
  const [activeId, setActiveId] = useState(null)
  const [formData, setFormData] = useState({
    state: "formData",
    view_type: "list",
    view_type_option: [{
      name: "List",
      value: "list"
    },
    {
      name: "Gallery",
      value: "grid"
    }]
  })
  const [analytics, setAnalytics] = useState({
    totalTodaySubscriber: 0,
    total_PPV_Purchase_revene: 0,
    total_Subscription_revene: 0,
    activeCurrency: null
  })

  const [debouncedTitle, setDebouncedTitle] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedTitle(formData.title);
    }, 500);
    return () => clearTimeout(timer);
  }, [formData.title]);

  const fetchAnalytics = async () => {
    try {
      const response = await fetchRequest({
        method: 'GET',
        url: `${BaseUrl}/admin/users/dashboard`,
        params: {},
        data: {},
      });

      if (response?.status) {
        setAnalytics({
          totalSubscriber: response?.total_user_subscription,
          totalTodaySubscriber: response?.total_recent_subscription,
          total_PPV_Purchase_revene: response?.total_PPVPurchase_revenue,
          total_Subscription_revene: response?.total_Subscription_revenue,
          activeCurrency: response?.activeCurrency
        });
      }
    } catch (error) {
      console.error('Failed to fetch analytics:', error);
    }
  };

  const fetchData = async () => {
    setLoading(true)
    await fetchRequest({
      method: 'GET',
      url: `${listApi}`,
      params: {
        type, page,
        limit: limit,
        search: debouncedTitle,
        soft_delete: draft
      },
      data: {},
    })
      .then(response => {
        const result = response;
        const updatedList = result?.data?.map((item) => {
          const UploadStatus = item?.uploaded_by_role;
          const statusText = item?.active === 1 ? "Active" : item?.active === 0 || item?.active === null ? "In-Active" : "DRAFT";
          return {
            ...item, roleText: UploadStatus, active: statusText
          };
        });
        setApiData(updatedList);
        setTotal(result?.pagination)
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
      })
  };

  const fetchAllData = async (type, find) => {
    const data = await fetchRequest({
      method: 'GET',
      url: `${listApi}`,
      params: {
        search: find === "ALL" ? null : debouncedTitle,
        type: null,
        page: 1,
        limit: find === "ALL" ? total?.count_all : total?.totalItems,
        soft_delete: draft,
      },
      data: {},
    });

    let updatedList;

    if (find === "ALL") {
      updatedList = data?.data || [];
    } else {
      if (!itemToDelete || itemToDelete.length === 0) {
        alert("Please select at least one row to export.");
        return;
      }
      updatedList = data?.data?.filter(item => itemToDelete.includes(item?.id));
      if (!updatedList || updatedList.length === 0) {
        alert("Selected data not found.");
        return;
      }
    }

    const exportData = updatedList.map((item, index) => ({
      "S.NO": index + 1,
      "ID": item?.id,
      "USERNAME": item?.username,
      "E-MAIL": item?.email,
      "CONTACT": item?.mobile,
      "SUBSCRIBER PLAN": item?.subscription_plan_name || "No Plan",
      "PLAN START": item?.subscription_starts_at_formatted || "N/A",
      "PLAN END": item?.subscription_ends_at_formatted || "N/A",
      "ROLE": item?.uploaded_by_role,
    }));

    if (type === "CSV") {
      await donwloadCSV(exportData, "USER-LIST");
    } else if (type === "PDF") {
      await videodownloadPDF(exportData, "USER-LIST", [
        "S.NO", "ID", "USERNAME", "E-MAIL", "CONTACT", "SUBSCRIBER PLAN", "PLAN START", "PLAN END", "ROLE"
      ]);
    } else if (type === "XLSX") {
      await videodownloadXLSX(exportData, "USER-LIST", [
        "S.NO", "ID", "USERNAME", "E-MAIL", "CONTACT", "SUBSCRIBER PLAN", "PLAN START", "PLAN END", "ROLE"
      ]);
    }
  };

  const handleDeleteImage = async () => {
    await deleteImageFile(itemToDelete, "User");
  }

  const handleConfirmDelete = async () => {
    setShowOverlay(true);
    await handleDeleteImage();
    await fetchRequest({
      method: 'DELETE',
      url: `${multiDelete}`,
      params: {},
      data: { id: itemToDelete, action: deleteActionType },
    })
      .then(response => {
        const result = response;
        if (result?.status) {
          toast.success(result?.message);
          setItemToDelete([])
        }
      })
      .catch(error => {
        toast.error(error?.response?.data?.message || error?.message)
      }).finally(() => {
        setShowOverlay(false)
        setWithoutRefresh(!withOutRefresh);
      })
  };

  const closeModal = () => {
    setModelClose(!closeModal);
    setShowModal(false);
    setItemToDelete([])
  };

  const openModal = () => {
    setModelClose(true);
  };

  const singleDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id]);
    if (draft === 1) {
      setDeleteActionType(3)
      setPermanent(0)
    }
  };

  const singlePeramanentDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id]);
    setPermanent(1)
    setDeleteActionType(1)
  }

  const handleDeletedata = () => {
    handleConfirmDelete();
    closeModal();
  };

  const handleInput = (e) => {
    const { type, name, value, checked } = e.target
    if (type === "search") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }))
    }
    if (type === 'select-one') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  }

  const userFormatter = (data, row) => {
    return (
      <div className="d-flex flex-column gap-1">
        <p className="userNameProfile text-break mb-0">{data}</p>
        <span className="userDateText">{row?.upload_on}</span>
      </div>
    );
  };

  const planFormatter = (cell, row) => {
    const isSubscriber = String(row?.role) === "3";

    if (isSubscriber) {
      const hasPlanName = row?.subscription_plan_name && row?.subscription_plan_name !== "No Plan";
      return (
        <div className="d-flex flex-column gap-1">
          <span className="fw-bold">{hasPlanName ? row.subscription_plan_name : "No Plan"}</span>
          {row?.payment_plans_id && <span className="userDateText text-break">{row.payment_plans_id}</span>}
        </div>
      );
    }

    return (
      <div className="d-flex flex-column gap-1 text-center">
        <span className="">-</span>
      </div>
    );
  };

  const periodFormatter = (cell, row) => {
    // Subscriber role is ID 3.
    const isSubscriber = String(row?.role) === "3";

    if (!isSubscriber) {
      return (
        <div className="d-flex flex-column gap-1 text-center">
          <span className="">-</span>
        </div>
      );
    }

    const isExpired = isSubscriber && row.subscription_ends_at && new Date(row.subscription_ends_at) < new Date();
    const endDate = row?.subscription_ends_at_formatted || "N/A";

    return (
      <div className="d-flex flex-column gap-1">
        <span className="userDateText">Start: {row?.subscription_starts_at_formatted || "N/A"}</span>
        <span className={`userDateText ${isExpired ? "text-danger fw-bold" : isSubscriber && endDate !== "N/A" ? "text-success fw-bold" : ""}`}>
          {isExpired ? `Expired on ${endDate}` : `End on ${endDate}`}
        </span>
      </div>
    );
  };

  const columns = [
    {
      dataField: "username",
      text: "Users",
      formatter: userFormatter,
      sort: true,
      classes: "userDesignBox",
      headerClasses: "userDesignBox"
    },

    {
      dataField: "mobile",
      text: "Contact",
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return <span className="text-break  d-flex align-items-center justify-content-center w-100">{cell}</span>
      }
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
      headerClasses: "userEmailBox"
    },
    {
      dataField: "roleText",
      text: "Role",
      sort: true,
    },
    {
      dataField: "active",
      text: "Status",
      sort: true,
      formatter: (cell, row) => statusActiveFormatteruser(cell, row),
    },
    {
      dataField: "subscription_plan_name",
      text: "Subscriber Plan",
      formatter: planFormatter,
      sort: true,
    },
    {
      dataField: "subscription_ends_at",
      text: "Plan Period",
      formatter: periodFormatter,
      sort: true,
    },
    {
      dataField: "ACTIONS",
      text: "Actions",
      formatter: (cell, row) => <div className="editdropdown"
        onClick={() => setActiveId(row.id)}
        onMouseLeave={() => setActiveId(null)}
        id={`moreOption`}>
        <span className="editdropdown-button">
          <FaEllipsisVertical />
        </span>
        <div className={`editdropdown-menu theme-bg-color ${activeId == row?.id ? "d-block" : "d-none"}  ${formData?.view_type}`}>
          {draft !== 1 && <Link id={`Edit `} to={`${"/edit-users/"}${row?.id}`} className="theme-text-color  theme-bg-color">
            <span className="theme-text-color">
              <IconEditFigma styled={{ width: "20px", height: "20px" }} />
              <MessageBox text="Edit" classname='ms-2 theme-text-color'></MessageBox>
            </span>
          </Link>}
          <div id={`deleteButton`} onClick={() => singleDelete(row?.id)} className="commonActionPadding theme-bg-color">
            {draft == 1 ? <LiaUndoAltSolid style={{ width: "20px", height: "20px" }} /> : <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />}
            <MessageBox text={`${draft == 1 ? "undo" : "Delete"}`} classname='ms-2 theme-text-color'></MessageBox>
          </div>
          {draft == 1 && (<div id={`permanentDeleteButton`} onClick={() => singlePeramanentDelete(row?.id)} className="commonActionPadding theme-bg-color">
            <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />
            <MessageBox text="Delete Permanent" classname='ms-2 theme-text-color'></MessageBox>
          </div>)}
        </div>
      </div >
    },
  ];

  const options = {
    pageStartIndex: 1,
    paginationSize: 3,
    sizePerPage: 10,
  };

  const selectRow = {
    selected: itemToDelete,
  };

  const handleRowSelect = (rowId) => {
    if (itemToDelete.includes(rowId)) {
      setItemToDelete(itemToDelete.filter((id) => id !== rowId));
    } else {
      setItemToDelete([...itemToDelete, rowId]);
    }
  };

  const handleSort = (field) => {
    const sortedData = [...apiData].sort((a, b) => {
      if (a[field] < b[field]) return -1;
      if (a[field] > b[field]) return 1;
      return 0;
    });
    setApiData(sortedData);
  };

  const handleSelectAll = () => {
    if (itemToDelete.length === apiData.length) {
      setItemToDelete([]);
    } else {
      setItemToDelete(apiData.map((row) => row.id));
    }
  };

  const reloadAction = () => {
    setDraft(0)
    setWithoutRefresh(prev => !prev)
    setApiData([])
    setAnalytics((prev) => ({
      ...prev,
      totalSubscriber: 0,
      totalTodaySubscriber: 0,
      total_Subscription_revene: 0,
      total_PPV_Purchase_revene: 0,
      activeCurrency: null
    }))
  }

  const reCycleBin = () => {
    setDraft(prev => prev === 1 ? 0 : 1);
    setItemToDelete([]);
  };

  useEffect(() => {
    fetchData();
  }, [page, limit, debouncedTitle, withOutRefresh, draft]);

  useEffect(() => {
    fetchAnalytics();
  }, [withOutRefresh]);

  useEffect(() => {
    if (draft === 0) {
      setDeleteActionType(2)
    }
    if (draft === 1) {
      setDeleteActionType(3)
    }
    if (draft === 1 && Permanent == 1) {
      setDeleteActionType(1)
    }
  }, [draft, Permanent])

  return (
    <>
      {showOverlay && <Response_Processing />}
      {modelClose && <AdminDeleteModal headingText={(draft === 1 && Permanent === 1) ? "Confirm Permanent Deletion" : (draft === 1) ? "Confirm Undo" : "Confirm Delete"} message={(draft === 1 && Permanent === 1) ? "Are you sure you want to permanent delete this items" : (draft === 1) ? "Are you sure you want to undo this items" : "Are you sure you want to delete this items"} modelClose={modelClose} deleteClose={closeModal} deleteAction={handleDeletedata} buttonText={"custom"} actionText={(draft === 1 && Permanent === 1) ? "Delete Permanent" : (draft === 1) ? "Undo" : "Delete"} />}
      <section className="pb-4">
        <div className="d-flex align-items-center justify-content-between flex-wrap">
          <div className="col-12 col-md-6 col-lg-3  p-2">
            <div className="text-center theme-bg-color p-3 rounded-3 alluser_card_number">
              <p className="countHead mb-2"> {analytics?.totalSubscriber}</p>
              <p className="countHead mb-1">Total Subcribers</p>
              <span className="countDes">The Total Amount Of Subscribers On Your Site.</span>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-3  p-2">
            <div className="text-center theme-bg-color p-3 rounded-3 alluser_card_number">
              <p className="countHead mb-2"> {analytics?.totalTodaySubscriber}</p>
              <p className="countHead mb-1">New Subcribers</p>
              <span className="countDes">New Subscribers For Today.</span>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-3  p-2">
            <div className="text-center theme-bg-color p-3 rounded-3 alluser_card_number ">
              <p className="countHead mb-2"> {analytics?.activeCurrency?.symbol} {analytics?.total_Subscription_revene}</p>
              <p className="countHead mb-1">Subscription Revenue</p>
              <span className="countDes">Total Revenue</span>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-3  p-2">
            <div className="text-center theme-bg-color p-3 rounded-3 alluser_card_number ">
              <p className="countHead mb-2"> {analytics?.activeCurrency?.symbol} {analytics?.total_PPV_Purchase_revene}</p>
              <p className="countHead mb-1">PPV Revenue</p>
              <span className="countDes">Total Revenue</span>
            </div>
          </div>
        </div>
      </section>
      <AdminNavbar heading={"All Users"} totalDataLength={total?.totalItems} deleteCount={itemToDelete?.length} navigation={"/add-users"} deleteMethod={openModal} navText={"Add Users"} />

      <div className='theme-bg-color p-3 rounded-3 mb-5'>
        <div className='d-flex align-items-center flex-wrap justify-content-between  mb-3'>
          <input type='search' placeholder='Search' name="title" className='rounded-3  theme-border-color border-solid-width border-solid table-search   theme-bg-color-secondary' onChange={handleInput} id='searchInput' />
          <div className=' d-flex align-items-center'>
            <button className={` reloadButton p-2 me-2 custom-tool-tip-parent  border border-2 rounded-circle theme-border-color ${draft ? "button-bg-color theme-button-text-color" : " bg-transparent theme-text-color"}`} onClick={reCycleBin} id='recycleButton'>
              <BiRecycle style={{ width: "18px", height: "15px" }} />
              <AdminTooltip text="Recycle Bin" top={"-41px"} className="d-none custom-tool-tip" />

            </button>
            <button className={`bg-transparent reloadButton custom-tool-tip-parent theme-text-color p-2 me-2 primary border border-2 rounded-circle theme-border-color`} onClick={reloadAction} id='reloadButton'>
              <RxReload style={{ width: "18px", height: "15px" }} className={`${loading ? "rotate-load" : ""}`} />
              <AdminTooltip text="Refresh" top={"-41px"} className="d-none custom-tool-tip" />

            </button>
            <div className="dropdown d-block ms-2 " key={"2"}>
              <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="exportButton" data-bs-toggle="dropdown" aria-expanded="false"  >
                <span className="fw-bolder text-white">Export</span>
                <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
              </button>
              <ul className="dropdown-menu theme-bg-color" aria-labelledby="exportButton" >
                <li className="dropdown-item theme-text-color" id='exportCSV' onClick={() => fetchAllData("CSV")}>CSV</li>
                <li className="dropdown-item theme-text-color" id='exportPDF' onClick={() => fetchAllData("PDF")}>PDF</li>
                <li className="dropdown-item theme-text-color" id='exportXLSX' onClick={() => fetchAllData("XLSX")}>XLSX </li>
              </ul>
            </div>
            <div className="dropdown d-block ms-2 " key={"2"}>
              <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="exportAllButton" data-bs-toggle="dropdown" aria-expanded="false"  >
                <span className="fw-bolder text-white">Export all</span>
                <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
              </button>
              <ul className="dropdown-menu theme-bg-color" aria-labelledby="exportAllButton" >
                <li className="dropdown-item theme-text-color" id='exportAllCSV' onClick={() => fetchAllData("CSV", "ALL")}>CSV</li>
                <li className="dropdown-item theme-text-color" id='exportAllPDF' onClick={() => fetchAllData("PDF", "ALL")}>PDF</li>
                <li className="dropdown-item theme-text-color" id='exportAllXLSX' onClick={() => fetchAllData("XLSX", "ALL")}>XLSX </li>
              </ul>
            </div>
          </div>
        </div>

        <AdminTable data={apiData}
          loading={loading}
          options={options}
          handlePageChange={handlePageChange}
          page={page}
          pagination={total}
          handleSizePerPageChange={handleSizePerPageChange}
          columns={columns}
          limit={limit}
          selectRow={selectRow}
          multiSelect
          onRowSelect={handleRowSelect}
          onSort={handleSort}
          onSelectAll={handleSelectAll}
          viewType={formData?.view_type}
        />
      </div >
    </>
  );
}

export default AllUser;